
import logo from './../assets/imgs/waylytyx-icon.png';

const Logo = () => {
    return <img src={logo} alt="Waylytyx Logo"  height='40px' />;
  };
  
export default Logo;